module.exports = __webpack_public_path__ + "static/kashkick-review-6d4a0c3a49bbc12dcbd745b962fc1d59.png";